$(document).ready(function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});
var $form_response = null;
var nameEventLabel= '';
var nameEventCategory = '';
if ($("#form_schedule").length > 0) {
    $("#form_schedule").validate({

        rules: {
            datetime: {
                required: true,
            },
            hear: {
                required: true,
            },
            hear2: {
                required: true,
            },
            appointmentTypeID: {
                required: true,
            },
            firstName: {
                required: true,
            },
            lastName: {
                required: true,
            },
            phone: {
                required: true,
                digits:true,
                minlength: 6,
                maxlength:12,
            },
            email: {
                required: true,
                maxlength: 50,
                email: true,
            },
        },
        messages: {

            datetime: {
                required: "Please choose date",
            },
            appointmentTypeID: {
                required: "Please choose appointment",
            },
            hear: {
                required: "Please choose how did you hear about us",
            },
            hear2: {
                required: "What keyword search did you use?",
            },
            firstName: {
                required: "Please enter First Name",
            },
            lastName: {
                required: "Please enter Last Name",
            },
            phone: {
                required: "Please enter contact number",
                minlength: "The contact number should be 6 digits",
                digits: "Please enter only numbers",
                maxlength: "The contact number should be 12 digits",
            },
            email: {
                required: "Please enter valid email",
                email: "Please enter valid email",
                maxlength: "The email name should less than or equal to 50 characters",
            },

        },
        submitHandler: function(form) {
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });
            $('#send_form').html('Sending..');
            $.ajax({
                url: '/api/appointment/send',
                type: "POST",
                data: $('#form_schedule').serialize(),
                success: function( response ) {
                    $form_response = response;

                    let appAmount = localStorage.getItem('AppAmount');
                    if (appAmount==="0.00") {
                        nameEventCategory = $('#eventCategory').attr('value')
                        nameEventLabel = $('#eventLabel').attr('value')

                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push(null);

                        window.dataLayer.push({
                            'eventName': 'form_submission_no_pay',
                            'event':'lead',
                            'eventLabel': nameEventLabel,
                            'eventCategory':nameEventCategory,
                        });

                        $('#send_form').html('Submit');
                        if ($('input[name="payed"]').val() == 1) {
                            $.ajax({
                                url: '/api/appointment/pay',
                                type: "POST",
                                data: {
                                    id : response.id,
                                    amount: localStorage.getItem('AppAmount'),
                                },
                            })
                        }
                        $('#res_message').show();
                        $('#res_message').html(response.msg);
                        $('#msg_div').removeClass('d-none');
                        $('.program-schedule__content').html(response.firstName+' '+response.lastName)
                        $('.program-schedule__title').html(response.type)
                        $('.program-schedule__price').html(response.date+' '+response.time)
                        $('.program-schedule__lesson').html(response.calendar)
                        $('.program-schedule__bottom').remove()
                        // document.getElementById("form_schedule.create").reset();
                        $('.introductory-tabs__item').each(function () {
                            $(this).removeClass('is-show')
                        })
                        setTimeout(function(){
                            $('#res_message').hide();
                            $('#msg_div').hide();
                        },10000);
                    }
                }
            });
        }
    })
}


// mma nyc - mma classes && selfdefence

$(document).ready(function () {
    $(".first-btn, #send_form").addClass("validate-btn");
    var classes = "";
    var ids = localStorage.getItem("AppTypes").split(",");
    $.ajax({
        method: "GET",
        url: "/api/appointment_types",
        data: { ids: ids },
    }).done(function (data) {
        // select lessons data
        $(".input-date").addClass("is-show");
        $.each(data, function () {
            var name = "";
            if ($(this)[0].custom_name === null) {
                name = $(this)[0].name;
            } else {
                name = $(this)[0].custom_name;
            }
            var eventCategory = $(this)[0].event_category
                ? $(this)[0].event_category
                : "introductory_class";
            var eventLabel = $(this)[0].event_label
                ? $(this)[0].event_label
                : "introductory_class";

            classes +=
                '<option value="' +
                $(this)[0].api_id +
                '" data-amount="' +
                $(this)[0].price +
                '" data-event-category="' +
                eventCategory +
                '" data-event-label="' +
                eventLabel +
                '">' +
                name +
                "</option>";
        });

        localStorage.setItem("AppName", data[0].name);
        localStorage.setItem("AppAmount", data[0].price);
        $('input[name="appointmentTypeID"]').val(data[0].api_id);
        $("#choose_class").html(classes);

        var currentCategory = $("#choose_class")
            .children("option:selected")
            .attr("data-event-category");
        var currentLabel = $("#choose_class")
            .children("option:selected")
            .attr("data-event-label");

        $('input[name="eventCategory"]').val(currentCategory);
        $('input[name="eventLabel"]').val(currentLabel);

        if (localStorage.getItem("AppAmount") > 0) {
            let cost = localStorage.getItem("AppAmount");
            cost = Number(cost).toFixed(2);
            $("#buttons").html(
                '<button type="button" id="pay" class="btn btn-secondary btn-block">Pay $' +
                    cost +
                    "</button>"
            );
            $("#pay").on("click", function () {
                nameEventCategory = $("#eventCategory").attr("value");
                nameEventLabel = $("#eventLabel").attr("value");

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(null);

                window.dataLayer.push({
                    eventName: "form_submission_no_pay",
                    event: "lead",
                    eventLabel: nameEventLabel,
                    eventCategory: nameEventCategory,
                });
                $('input[name="payed"]').val(0);
                $("#form_schedule").submit();

                var amount = localStorage.getItem("AppAmount");
                var closePopUp = true;
                var handler = StripeCheckout.configure({
                    key: process.env.MIX_STRIPE_KEY,
                    locale: "us",
                    token: function (token) {
                        $("#token_response").html(JSON.stringify(token));
                        closePopUp = false;

                        $.ajax({
                            url: "/stripe",
                            method: "post",
                            data: { tokenId: token.id, amount: amount },
                            success: (response) => {
                                $("#buttons").html(
                                    '<button class="btn btn-secondary"  id="send_form" type="submit">Try Now</button>'
                                );

                                fbq("track", "SubmitApplication");
                                dataLayer.push({
                                    event: "ScheduleTrialClass",
                                });
                                $('input[name="payed"]').val(1);
                                $("#send_form").html("Submit");

                                $.ajax({
                                    url: "/api/appointment/pay",
                                    type: "POST",
                                    data: {
                                        id: $form_response.id,
                                        amount: localStorage.getItem(
                                            "AppAmount"
                                        ),
                                    },
                                    success: function (response) {
                                        $("#res_message").show();
                                        $("#res_message").html(
                                            $form_response.msg
                                        );
                                        $("#msg_div").removeClass("d-none");
                                        $(".program-schedule__content").html(
                                            $form_response.firstName +
                                                " " +
                                                $form_response.lastName
                                        );
                                        $(".program-schedule__title").html(
                                            $form_response.type
                                        );
                                        $(".program-schedule__price").html(
                                            $form_response.date +
                                                " " +
                                                $form_response.time
                                        );
                                        $(".program-schedule__lesson").html(
                                            $form_response.calendar
                                        );
                                        $(".program-schedule__bottom").remove();
                                        // document.getElementById("form_schedule.create").reset();
                                        $(".introductory-tabs__item").each(
                                            function () {
                                                $(this).removeClass("is-show");
                                            }
                                        );
                                        setTimeout(function () {
                                            $("#res_message").hide();
                                            $("#msg_div").hide();
                                        }, 10000);

                                        window.dataLayer =
                                            window.dataLayer || [];
                                        window.dataLayer.push(null);

                                        window.dataLayer.push({
                                            eventName:
                                                "form_submission_success_pay",
                                            event: "Start trial",
                                            eventLabel: nameEventLabel,
                                            eventCategory: nameEventCategory,
                                            eventValue: amount,
                                        });
                                    },
                                });
                            },
                            error: (error) => {
                                console.log(error);
                                alert("There is an error in processing.");
                            },
                        });
                    },
                    closed: function () {
                        if ($form_response && $form_response.id && closePopUp) {
                            $.ajax({
                                url: '/api/appointment/ajax-cancel/'+$form_response.id,
                                type: "GET"
                            })
                        }
                    }
                });

                handler.open({
                    name: localStorage.getItem("AppName"),
                    amount: amount * 100,
                });
            });
        } else {
            $("#buttons").html(
                '<button class="btn btn-secondary"  id="send_form" type="submit">Try Now</button>'
            );
        }
        var dates_list = [];
        $.ajax({
            method: "GET",
            url: "/api/availability/dates",
            data: { id: data[0].api_id },
        }).done(function (data) {
            $(".input-date").addClass("is-show");
            $.each(data, function () {
                dates_list.push(moment($(this)[0].date).format("M/D/YYYY"));
            });
            getNextMonth();
        });

        function getNextMonth() {
            var nextMonth = moment().add(1, "M").format("YYYY-MM");
            $.ajax({
                method: "GET",
                url: "/api/availability/dates?month=" + nextMonth,
                data: { id: data[0].api_id },
            }).done(function (data) {
                $(".input-date").addClass("is-show");
                $.each(data, function () {
                    dates_list.push(moment($(this)[0].date).format("M/D/YYYY"));
                });

                if (!dates_list.length) {
                    dates_list = [""];
                }
                $(".input-date").each(function () {
                    $(this).datetimepicker({
                        timepicker: false,
                        allowDates: dates_list,
                        formatDate: "M/D/YYYY",
                        scrollMonth: false,
                        scrollInput: false,
                    });
                });
            });
        }

        $.datetimepicker.setLocale("en");
        $.datetimepicker.setDateFormatter({
            parseDate: function (date, format) {
                var d = moment(date, "M/D/YYYY");
                return d.isValid() ? d.toDate() : false;
            },
            formatDate: function (date, format) {
                return moment(date).format("M/D/YYYY");
            },
        });

        if (!dates_list.length) {
            dates_list = [""];
        }
        $(".input-date").each(function () {
            $(this).datetimepicker({
                timepicker: false,
                allowDates: dates_list,
                formatDate: "M/D/YYYY",
                scrollMonth: false,
                scrollInput: false,
            });
        });
    });
});

// choose class
$(document).on("change", "#choose_class", function () {
    var dates = "";
    var dates_list = [];
    var $this = $(this);

    var event_category = $this
        .children("option:selected")
        .attr("data-event-category");
    var event_label = $this
        .children("option:selected")
        .attr("data-event-label");
    $('input[name="appointmentTypeID"]').val($this.val());

    $('input[name="eventCategory"]').val(event_category);
    $('input[name="eventLabel"]').val(event_label);

    localStorage.setItem("AppName", $this.children("option:selected").html());
    localStorage.setItem(
        "AppAmount",
        $this.children("option:selected").data("amount")
    );
    if (localStorage.getItem("AppAmount") > 0) {
        let cost = localStorage.getItem("AppAmount");
        cost = Number(cost).toFixed(2);
        $("#buttons").html(
            '<button type="button" id="pay" class="btn btn-secondary btn-block">Pay $' +
                cost +
                "</button>"
        );
        $("#pay").on("click", function () {
            var amount = localStorage.getItem("AppAmount");
            var nameEventCategory = $("#eventCategory").attr("value");
            var nameEventLabel = $("#eventLabel").attr("value");

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(null);

            window.dataLayer.push({
                eventName: "form_submission_no_pay",
                event: "lead",
                eventLabel: nameEventLabel,
                eventCategory: nameEventCategory,
            });

            $('input[name="payed"]').val(0);
            $("#form_schedule").submit();

            var handler = StripeCheckout.configure({
                key: process.env.MIX_STRIPE_KEY,
                locale: "us",
                token: function (token) {
                    $("#token_response").html(JSON.stringify(token));

                    $.ajax({
                        url: "/stripe",
                        method: "post",
                        data: { tokenId: token.id, amount: amount },
                        success: (response) => {
                            $("#buttons").html(
                                '<button class="btn btn-secondary"  id="send_form" type="submit">Try Now</button>'
                            );
                            $('input[name="payed"]').val(1);

                            fbq("track", "SubmitApplication");
                            dataLayer.push({ event: "ScheduleTrialClass" });
                            $('input[name="payed"]').val(1);
                            $("#send_form").html("Submit");

                            $.ajax({
                                url: "/api/appointment/pay",
                                type: "POST",
                                data: {
                                    id: $form_response.id,
                                    amount: localStorage.getItem("AppAmount"),
                                },
                                success: function (response) {
                                    $("#res_message").show();
                                    $("#res_message").html($form_response.msg);
                                    $("#msg_div").removeClass("d-none");
                                    $(".program-schedule__content").html(
                                        $form_response.firstName +
                                            " " +
                                            $form_response.lastName
                                    );
                                    $(".program-schedule__title").html(
                                        $form_response.type
                                    );
                                    $(".program-schedule__price").html(
                                        $form_response.date +
                                            " " +
                                            $form_response.time
                                    );
                                    $(".program-schedule__lesson").html(
                                        $form_response.calendar
                                    );
                                    $(".program-schedule__bottom").remove();
                                    // document.getElementById("form_schedule.create").reset();
                                    $(".introductory-tabs__item").each(
                                        function () {
                                            $(this).removeClass("is-show");
                                        }
                                    );
                                    setTimeout(function () {
                                        $("#res_message").hide();
                                        $("#msg_div").hide();
                                    }, 10000);

                                    window.dataLayer = window.dataLayer || [];
                                    window.dataLayer.push(null);

                                    window.dataLayer.push({
                                        eventName:
                                            "form_submission_success_pay",
                                        event: "Start trial",
                                        eventLabel: nameEventLabel,
                                        eventCategory: nameEventCategory,
                                        eventValue: amount,
                                    });
                                },
                            });
                        },
                        error: (error) => {
                            console.log(error);
                            alert("There is an error in processing.");
                        },
                    });
                },
                closed: function () {
                    if ($form_response && $form_response.id){
                        $.ajax({
                            url: '/api/appointment/ajax-cancel/'+$form_response.id,
                            type: "GET"
                        })
                    }
                }
            });

            handler.open({
                name: localStorage.getItem("AppName"),
                amount: amount * 100,
            });
        });
    } else {
        $("#buttons").html(
            '<button class="btn btn-secondary"  id="send_form" type="submit">Try Now</button>'
        );
    }
    $.ajax({
        method: "GET",
        url: "/api/availability/dates",
        data: { id: $this.val() },
    }).done(function (data) {
        $(".input-date").addClass("is-show");
        $.each(data, function () {
            dates_list.push(moment($(this)[0].date).format("M/D/YYYY"));
        });
        getNextMonth();
    });

    function getNextMonth() {
        var nextMonth = moment().add(1, "M").format("YYYY-MM");
        $.ajax({
            method: "GET",
            url: "/api/availability/dates?month=" + nextMonth,
            data: { id: $this.val() },
        }).done(function (data) {
            $(".input-date").addClass("is-show");
            $.each(data, function () {
                dates_list.push(moment($(this)[0].date).format("M/D/YYYY"));
            });

            if (!dates_list.length) {
                dates_list = [""];
            }
            $(".input-date").each(function () {
                $(this).datetimepicker({
                    timepicker: false,
                    allowDates: dates_list,
                    formatDate: "M/D/YYYY",
                    scrollMonth: false,
                    scrollInput: false,
                });
            });
        });
    }

    $.datetimepicker.setLocale("en");
    $.datetimepicker.setDateFormatter({
        parseDate: function (date, format) {
            var d = moment(date, "M/D/YYYY");
            return d.isValid() ? d.toDate() : false;
        },
        formatDate: function (date, format) {
            return moment(date).format("M/D/YYYY");
        },
    });

    if (!dates_list.length) {
        dates_list = [""];
    }
    $(".input-date").each(function () {
        $(this).datetimepicker({
            timepicker: false,
            allowDates: dates_list,
            formatDate: "M/D/YYYY",
            scrollMonth: false,
            scrollInput: false,
        });
    });
});

// change date
$(document).on("change", ".input-date", function () {
    var times = "";
    $(".is-open").removeClass("is-open");
    var $this = $(this);
    var $modal = $this.closest(".select");
    $modal.find(".select-btn span").text($this.text());
    $.ajax({
        method: "GET",
        url: "/api/availability/times",
        data: {
            id: $('input[name="appointmentTypeID"]').val(),
            date: moment($(this).val(), "M/D/YYYY").format("D.M.YYYY"),
        },
    }).done(function (data) {
        $(".select-time").removeClass("is-show");
        if ($this.val() != "") {
            $(".select-time").addClass("is-show");
            var {convertDateTimeToUSAFormat} = require('./helpers/dateTimeToUSAFormat.js');
            $.each(data, function () {
                times +=
                    '<li class="select-item"><a data-time="' +
                    $(this)[0].time +
                    '" class="select-link-time" href="javascript:void(0);">' +
                    convertDateTimeToUSAFormat($(this)[0].time) +
                    "</a></li>";
            });
            $("#time .select-list").html(times);
        }
    });
});
$(document).on("click", ".select-link-time", function () {
    $(".is-open").removeClass("is-open");
    var $this = $(this);
    var $modal = $this.closest(".select");
    $modal.find(".select-btn span").text($this.text());
    $('input[name="datetime"]').val($this.data("time"));
});
$(document).on("click", ".select-link-hear", function () {
    $(".is-open").removeClass("is-open");
    var $this = $(this);
    var $modal = $this.closest(".select");
    $modal.find(".select-btn span").text($this.text());
    $('input[name="hear"]').val($this.text());
});

$(document).on("change, keyup", "#form_schedule input", function () {
    checkValid();
});

function checkValid() {
    $(".first-btn, #send_form, #pay").addClass("validate-btn");
    if (
        $('input[name="hear"]').val() &&
        $('input[name="hear2"]').val() &&
        $('input[name="datetime"]').val()
    ) {
        $(".first-btn").removeClass("validate-btn");
    }
    if (
        $('input[name="firstName"]').val() &&
        $('input[name="lastName"]').val() &&
        validNumber() &&
        $('input[name="email"]').val()
    ) {
        $("#pay").removeClass("validate-btn");
        $("#send_form").removeClass("validate-btn");
        $(".first-btn").removeClass("validate-btn");
    }
}


function validNumber() {
    const re = /^\d*(\.\d+)?$/;
    if( $('input[name="phone"]').val().length > 6 && $('input[name="phone"]').val().length <= 12 && $('input[name="phone"]').val().match(re)){
        return true;
    }else{
        return false;
    }
}
